import React, { Component } from 'react'
import './index.less'
import { connect } from 'react-redux'
import { InputItem, ActionSheet, Toast } from 'antd-mobile'
import { fetchSubmitOrder } from '@/api/book';
import { setHeader } from '@/util/set-header'
const mapStateToProps = (state: any) => {
    return ({
        id: state.book.id,
        address: state.book.address,
        name: state.book.name,
        arrival_info: state.book.arrival_info,
        room_info: state.book.room_info,
        reserve_remark: state.book.reserve_remark,
        start_day: state.book.start_day,
        end_day: state.book.end_day,
        days: state.book.days,
        totalPrice: state.book.totalPrice,
    })
}

@(connect(
    mapStateToProps,
) as any)
export default class WriteInfo extends Component<any, any> {

    state = {
        bedNum: 1,
        phone: '',
        username: '',
        arrive_time: '',
        price: this.props.totalPrice,
    }

    UNSAFE_componentWillMount() {
        setHeader({ title: '填写预订信息' })
    }

    // 选择房间数量
    selectRoomNum = () => {
        const { room_info } = this.props
        const numList: any = [];
        for (let i = 1; i <= room_info.bed_count; i++) {
            numList.push(i)
        }

        ActionSheet.showActionSheetWithOptions(
            {
                options: numList,
                cancelButtonIndex: numList.length,
                message: '床位选择',
                maskClosable: true,
            },
            buttonIndex => {
                if (buttonIndex < numList.length) {
                    this.setState({
                        bedNum: numList[buttonIndex],
                        price: this.props.totalPrice * numList[buttonIndex]
                    })
                }
            },
        )
    }

    // 选择到达时间
    selectArriveTime = () => {
        const { arrival_info } = this.props
        
        if (arrival_info.length === 0) {
            Toast.show('当前无选择时间')
            return
        }
        const dataList: any = arrival_info.map((info: any) => (
            <div className="arrive-time">
                <span>{info.time}</span>
            </div>
        ))
        ActionSheet.showActionSheetWithOptions(
            {
                options: dataList,
                cancelButtonIndex: dataList.length,
                message: '最晚到店',
                maskClosable: true,
            },
            buttonIndex => {
                if (buttonIndex < dataList.length) {
                    this.setState({
                        arrive_time: arrival_info[buttonIndex].time
                    })
                }
            }
        )
    }

    // 用户姓名变化
    nameChange = (e: any) => {
        this.setState({
            username: e,
        })
    }

    // 用户手机号变化
    phoneChange = (e: any) => {
        this.setState({
            phone: e,
        })
    }

    // 提交订单
    submit = async () => {
        if (this.state.username === '') {
            Toast.show('姓名不能为空')
            return
        }

        var reg = /^1[3456789]\d{9}$/;
        if (this.state.phone === '') {
            Toast.show('手机号不可为空')
            return false;
        }
        if (!reg.test(this.state.phone)) {
            Toast.show('请输入有效的手机号码')
            return false;
        }

        if (this.state.arrive_time === '') {
            Toast.show('请选择到达时间')
            return
        }

        const roomType = {
            room_type_id: this.props.room_info.id,
            room_type_name: this.props.room_info.name,
            checkin_days: this.props.days
        }

        const param = {
            store_id: this.props.id,
            renter: this.state.username,
            phone: this.state.phone,
            start_day: this.props.start_day,
            end_day: this.props.end_day,
            room_type: roomType,
            deadline: this.state.arrive_time,
            reserve_bed_count: this.state.bedNum
        }

        Toast.loading('加载中')
        const data = await fetchSubmitOrder(param);
        
        if (data.code !== 'SUCCESS') {
            Toast.show(data.msg)
        } else {
            Toast.hide()
            const { history } = this.props
            history.push(`/book/book-detail?id=${data.data}`)
        }
    }

    // \n换成<br/>
    textWrap(str: any) {
        return str.replace(/\n|\r\n/g,"<br/>");
    }

    // 修改订单
    alterOrder = () => {
        const { history } = this.props
        history.push(`/book/booking`)
    }

    render() {
        return (
            <div className="info-body">
                <div className="all">
                    <div className="alter-order">
                        <div className="both-sides">
                            <span className="store-name">{this.props.name}</span>
                            <span className="alter" onClick={this.alterOrder}>修改订单</span>
                        </div>
                        <div className="store-address">{this.props.address}</div>
                        <div className="book-date">
                            <span>
                                <span className="check-date">入住：{this.props.start_day}</span>
                                <span className="go-date">离店：{this.props.end_day}</span>
                            </span>
                            <span className="go-date">{this.props.days}晚</span>
                        </div>
                        <div className="book-room">
                            <span>
                                <span className="room">房型：{this.props.room_info.name}</span>
                                <span className="room-price">单价：{this.props.room_info.day_price}元/天/床</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="room-number" onClick={this.selectRoomNum}>
                    <span>
                        <span className="color">床位数量：</span>
                        <span className="bed-number">{this.state.bedNum}个</span>
                    </span>
                    <img className="img" src="/public/assets/img/ic_more.png" alt="" />
                </div>
                <div className="phone">
                    <span className="phone-name">住客姓名：</span>
                    <InputItem
                        moneyKeyboardAlign="left"
                        style={{
                            fontSize: '16px',
                        }}
                        onChange={(e: any) => this.nameChange(e)}
                    ></InputItem>
                </div>
                <div className="phone">
                    <span className="phone-name">手机号码：</span>
                    <InputItem
                        moneyKeyboardAlign="left"
                        style={{
                            fontSize: '16px',
                        }}
                        onChange={(e: any) => this.phoneChange(e)}
                    ></InputItem>
                </div>
                <div className="arrive" onClick={this.selectArriveTime}>
                    <span>
                        <span className="color">最晚到店：</span>
                        <span className="arrive-date">{this.state.arrive_time}</span>
                    </span>
                    <img className="img" src="/public/assets/img/ic_more.png" alt="" />
                </div>
                <div className="description">
                    <span className="color">预订说明</span>
                </div>
                <div className="details">
                    <span className="color" dangerouslySetInnerHTML={{__html:this.textWrap(this.props.reserve_remark)}}></span>
                </div>
                <div className="bottom-button">
                    <div className="over-all">
                        <span className="total">
                            <span className="total-left">总价</span>
                            <span className="total-right">¥{this.state.price}</span>
                        </span>
                        <span className="submit" onClick={this.submit}>提交订单</span>
                    </div>
                </div>
            </div>
        )
    }
}